/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  H5pContent,
  ListToTeachExercisesParams,
  ListToTeachWorksheetsParams,
  PaginatedToTeachWorksheets,
  SchemaValidationErrorResponse,
  SearchToTeachWorksheetsParams,
  ToTeachExerciseCollection,
  ToTeachExerciseImportInput
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Import a ToTeach exercise as H5P content
 */
export const createToTeachExerciseImport = (
    toTeachExerciseImportInput?: MaybeRefOrGetter<ToTeachExerciseImportInput>,
 signal?: AbortSignal
) => {
      toTeachExerciseImportInput = toValue(toTeachExerciseImportInput);

      return axiosClient<H5pContent>(
      {url: `/to_teach/exercise_imports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: toTeachExerciseImportInput, signal
    },
      );
    }




export const getCreateToTeachExerciseImportMutationKey = () => ['createToTeachExerciseImport'] as const;

export const getCreateToTeachExerciseImportMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createToTeachExerciseImport>>, TError,CreateToTeachExerciseImportMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createToTeachExerciseImport>>, TError,CreateToTeachExerciseImportMutationVariables, TContext> => {

const mutationKey = getCreateToTeachExerciseImportMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createToTeachExerciseImport>>, CreateToTeachExerciseImportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createToTeachExerciseImport(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateToTeachExerciseImportMutationResult = NonNullable<Awaited<ReturnType<typeof createToTeachExerciseImport>>>
    export type CreateToTeachExerciseImportMutationBody = ToTeachExerciseImportInput | undefined
    export type CreateToTeachExerciseImportMutationError = ErrorType<SchemaValidationErrorResponse>
    export type CreateToTeachExerciseImportMutationVariables = {data?: ToTeachExerciseImportInput}

    /**
 * @summary Import a ToTeach exercise as H5P content
 */
export const useCreateToTeachExerciseImport = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createToTeachExerciseImport>>, TError,CreateToTeachExerciseImportMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createToTeachExerciseImport>>,
        TError,
        CreateToTeachExerciseImportMutationVariables,
        TContext
      > => {
      return useMutation(getCreateToTeachExerciseImportMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Exercises
 */
export const listToTeachExercises = (
    params?: MaybeRefOrGetter<ListToTeachExercisesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ToTeachExerciseCollection>(
      {url: `/to_teach/exercises`, method: 'GET',
        params, signal
    },
      );
    }




export const getListToTeachExercisesQueryKey = (params?: MaybeRefOrGetter<ListToTeachExercisesParams>,) => {
    return [
    'to_teach','exercises', ...(params ? [params] : [])
    ] as const;
    }


export const getListToTeachExercisesQueryOptions = <TData = Awaited<ReturnType<typeof listToTeachExercises>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListToTeachExercisesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listToTeachExercises>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListToTeachExercisesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listToTeachExercises>>> = ({ signal }) => listToTeachExercises(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listToTeachExercises>>, TError, TData>
}

export type ListToTeachExercisesQueryResult = NonNullable<Awaited<ReturnType<typeof listToTeachExercises>>>
export type ListToTeachExercisesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Exercises
 */

export function useListToTeachExercises<TData = Awaited<ReturnType<typeof listToTeachExercises>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListToTeachExercisesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listToTeachExercises>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListToTeachExercisesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Search worksheets for current user
 */
export const searchToTeachWorksheets = (
    params?: MaybeRefOrGetter<SearchToTeachWorksheetsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedToTeachWorksheets>(
      {url: `/to_teach/worksheet_search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchToTeachWorksheetsQueryKey = (params?: MaybeRefOrGetter<SearchToTeachWorksheetsParams>,) => {
    return [
    'to_teach','worksheet_search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchToTeachWorksheetsQueryOptions = <TData = Awaited<ReturnType<typeof searchToTeachWorksheets>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<SearchToTeachWorksheetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchToTeachWorksheets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchToTeachWorksheetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchToTeachWorksheets>>> = ({ signal }) => searchToTeachWorksheets(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchToTeachWorksheets>>, TError, TData>
}

export type SearchToTeachWorksheetsQueryResult = NonNullable<Awaited<ReturnType<typeof searchToTeachWorksheets>>>
export type SearchToTeachWorksheetsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Search worksheets for current user
 */

export function useSearchToTeachWorksheets<TData = Awaited<ReturnType<typeof searchToTeachWorksheets>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<SearchToTeachWorksheetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchToTeachWorksheets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchToTeachWorksheetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List of Worksheets
 */
export const listToTeachWorksheets = (
    params?: MaybeRefOrGetter<ListToTeachWorksheetsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedToTeachWorksheets>(
      {url: `/to_teach/worksheets`, method: 'GET',
        params, signal
    },
      );
    }




export const getListToTeachWorksheetsQueryKey = (params?: MaybeRefOrGetter<ListToTeachWorksheetsParams>,) => {
    return [
    'to_teach','worksheets', ...(params ? [params] : [])
    ] as const;
    }


export const getListToTeachWorksheetsQueryOptions = <TData = Awaited<ReturnType<typeof listToTeachWorksheets>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListToTeachWorksheetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listToTeachWorksheets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListToTeachWorksheetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listToTeachWorksheets>>> = ({ signal }) => listToTeachWorksheets(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listToTeachWorksheets>>, TError, TData>
}

export type ListToTeachWorksheetsQueryResult = NonNullable<Awaited<ReturnType<typeof listToTeachWorksheets>>>
export type ListToTeachWorksheetsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of Worksheets
 */

export function useListToTeachWorksheets<TData = Awaited<ReturnType<typeof listToTeachWorksheets>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListToTeachWorksheetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listToTeachWorksheets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListToTeachWorksheetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






